import { render, staticRenderFns } from "./BeauticianStatus.vue?vue&type=template&id=65d90dcc&scoped=true"
import script from "./BeauticianStatus.vue?vue&type=script&lang=js"
export * from "./BeauticianStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d90dcc",
  null
  
)

export default component.exports